const BaseView = require('./logo-type');

module.exports = BaseView.extend({
  type: 'vector',
  template: require('./vector-type.hbs'),
  ElementListView: require('./element-list/vectors-view'),
  basicHide: ['vector_add', 'vector_replace', 'vector_position', 'vector_colour', 'vector_z_index'],

  getTypeFilterRegex: function () {
    return /^vector_/;
  },

  initLibraryFolders: async function (type) {
  },

  selectSpecifyFolder: function () {
  },

  selectSpecifySource: function () {
    document.querySelector('#element-restrictions-source').checked = true;
    const sourceList = this.el.querySelector('.vector-replacement-options');
    sourceList.classList.toggle('hidden', false);
    this.initAddButton();
    this.logosListView.addElement(this.selection.source);
    this.recalculateSectionHeight(document.querySelector('#element-restrictions-source'));
  },

  renderDisabled: function () {
    this._renderColorDisabled();
    BaseView.prototype.renderDisabled.apply(this, arguments);
  },

  _renderColorDisabled: function () {
    const replaceColorInput = document.querySelector('#element-restrictions-color-content');
    const replaceColorSubInput = document.querySelector('#element-restrictions-colors');
    const replaceColorPaletteSubInput = document.querySelector('#element-restrictions-colors-library');
    const isReplaceOn = this.getOptionValue($(replaceColorInput));
    const isReplaceSpecifiedColorOn = this.getOptionValue($(replaceColorSubInput));
    const isReplaceSpecifiedPaletteOn = this.getOptionValue($(replaceColorPaletteSubInput));

    if (replaceColorInput) {
      this.el.querySelector('div[data-name="colors"]').classList.toggle('hidden', !isReplaceOn);
      this.el.querySelector('div[data-name="colors-library"]').classList.toggle('hidden', !isReplaceOn);

      if (replaceColorSubInput) {
        this.el.querySelector('.color-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedColorOn));
      }

      if (replaceColorPaletteSubInput) {
        this.el.querySelector('.palette-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedPaletteOn));
      }
    }
  }
});
